/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-return-assign */

import { groupBy } from 'lodash';
import moment from 'moment-timezone';

import { SALON_DETAILS_SUCCESS } from 'actions/fetchSalon.types';
import { CLIENTS_SMSTEXT_FAILURE, CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS } from 'actions/sms/beGetClientSmsText.types';
import logger from 'utils/logger.util';
import owns from 'utils/objects/owns.util';

import clientCommunicationsReducerDefaultState from 'clientCommunications/clientCommunicationsReducerDefaultState';
import {
  BULK_DELETE_CLIENT_FAILURE,
  BULK_DELETE_CLIENT_REQUEST,
  BULK_DELETE_CLIENT_SUCCESS,
  BULK_OPTOUT_CLIENT_FAILURE,
  BULK_OPTOUT_CLIENT_REQUEST,
  BULK_OPTOUT_CLIENT_SUCCESS,
  CLEAR_TIME_RANGE,
  CLIENTS_COUNT_FAILURE,
  CLIENTS_COUNT_REQUEST,
  CLIENTS_COUNT_SUCCESS,
  CLIENTS_DATA_FAILURE,
  CLIENTS_DATA_REQUEST,
  CLIENTS_DATA_SUCCESS,
  FILTER_CLIENT_DATA_SUCCESS,
  FILTER_CLIENTS_DATA_FAILURE,
  FILTER_CLIENTS_DATA_REQUEST,
  FILTER_LAST_VISIT,
  FILTER_LOYALTY,
  FILTER_NEXT_VISIT,
  FILTER_SELECTED_STYLISTS,
  FILTER_SERVICES,
  FILTER_TIME_RANGE,
  GET_AUTO_MESSAGES_FAILURE,
  GET_AUTO_MESSAGES_REQUEST,
  GET_AUTO_MESSAGES_SUCCESS,
  GET_CAMPAIGN_BOOKINGS_FAILURE,
  GET_CAMPAIGN_BOOKINGS_REQUEST,
  GET_CAMPAIGN_CLIENTS_FAILURE,
  GET_CAMPAIGN_CLIENTS_REQUEST,
  GET_CAMPAIGN_CLIENTS_SUCCESS,
  GET_MANUAL_MESSAGES_ONLY_FAILURE,
  GET_MANUAL_MESSAGES_ONLY_REQUEST,
  GET_MANUAL_MESSAGES_ONLY_SUCCESS,
  GET_MARKETING_CAMPAIGNS_FAILURE,
  GET_MARKETING_CAMPAIGNS_REQUEST,
  GET_MARKETING_CAMPAIGNS_SUCCESS,
  GET_UNIQUE_CLIENTS_ESTIMATE_FAILURE,
  GET_UNIQUE_CLIENTS_ESTIMATE_REQUEST,
  GET_UNIQUE_CLIENTS_ESTIMATE_SUCCESS,
  MARK_CLIENT_SELECT,
  PURCHASE_SMS_BUNDLE_FAILURE,
  PURCHASE_SMS_BUNDLE_REQUEST,
  PURCHASE_SMS_BUNDLE_SUCCESS,
  REST_BULK_DELETE_RESPONSE,
  SELECT_ALL_CLIENTS,
  SEND_MARKETING_SMS_FAILURE,
  SEND_MARKETING_SMS_REQUEST,
  SEND_MARKETING_SMS_SUCCESS,
  SET_AUTO_SMS_BY_MONTH,
  SET_HIDE_PHONE_VALUE,
  SET_MESSAGE_SENT,
  SET_OPT_VALUE,
  SET_SHOW_AUTOMSG_DETAILS,
  SET_SHOW_CAMPAIGN_DETAILS,
  SET_SMS_MESSAGE,
  SET_TIME_RANGE,
  SHOW_HIDE_NO_PHONE,
  SHOW_HIDE_OPT_CLIENTS,
  SMS_CREDITS_PUSHER,
  SORT_AUTO_MSG_CLIENT_LIST,
  SORT_AUTO_MSG_LIST,
  SORT_AUTO_SMS_BY_MONTH,
  SORT_CAMPAIGN_CLIENT_LIST,
  SORT_CAMPAIGN_LIST,
  SORT_CLIENT_LIST,
} from 'clientCommunications/constants';

const L = logger('clientCommunicationsReducer');

const clientCommunicationsReducer = (state = clientCommunicationsReducerDefaultState(), action) => {
  switch (action.type) {
    case CLIENTS_COUNT_REQUEST: {
      return {
        ...state,
        isFetchingCount: false,
      };
    }
    case CLIENTS_COUNT_SUCCESS: {
      // my prop name which I will use in mapStateToProps  = action.response
      const countClients = action.response;
      return {
        ...state,
        countClients,
        isFetchingCount: true,
      };
    }
    case CLIENTS_COUNT_FAILURE: {
      return {
        ...state,
        isFetchingCount: true,
      };
    }
    case PURCHASE_SMS_BUNDLE_REQUEST:
    case CLIENTS_SMSTEXT_REQUEST: {
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      };
    }
    case PURCHASE_SMS_BUNDLE_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        sms_credits_available: action.response.sms_credits_available,
        errorMessage: '',
      };
    }
    case PURCHASE_SMS_BUNDLE_FAILURE: {
      return {
        ...state,
        isFetching: false,
        errorMessage: 'bundle purchase failed',
      };
    }
    case CLIENTS_SMSTEXT_SUCCESS: {
      const clientSmsText = action.response;
      return {
        ...state,
        clientSmsText,
        isFetching: false,
      };
    }
    case CLIENTS_SMSTEXT_FAILURE: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case CLIENTS_DATA_REQUEST:
    case FILTER_CLIENTS_DATA_REQUEST: {
      let loadingClient = true;
      if (state.selectedLastVisit || state.selectedNextVisit || state.selectedLoyalty.isAnyAmount !== undefined) {
        loadingClient = false;
      }
      return {
        ...state,
        loadingClientsData: loadingClient,
        isFetching: true, // loadingClient,
      };
    }
    case CLIENTS_DATA_SUCCESS: {
      let activeList = action.response.map((p) => ({ ...p, selected: true, show: true }));
      //  Filter hide clients with no mobile
      if (state.isHideWithoutPhone) {
        activeList = activeList.map((client) => (client.phone !== null ? client : { ...client, selected: false, show: false }));
      }
      //  Filter show opted-in clients
      if (state.isOptChecked) {
        activeList = activeList.map((client) => (client.requested_opt_out === false ? client : { ...client, show: false }));
      }
      //  Disable opted-out clients
      activeList = activeList.map((client) => (client.requested_opt_out === true ? { ...client, selected: false } : client));
      activeList.sort((a, b) => (a.user_name.toLowerCase() < b.user_name.toLowerCase() ? -1 : 1));
      return {
        ...state,
        loadingClientsData: false,
        clientList: activeList,
        selectedLastVisit: '',
        selectedNextVisit: '',
        selectedServices: [],
        selectedStylistIds: [],
        selectedLoyalty: {
          isAnyAmount: undefined,
          amount: undefined,
          isAnyNumber: false,
          number: 0,
        },
        isFetching: false,
      };
    }
    case CLIENTS_DATA_FAILURE:
    case FILTER_CLIENTS_DATA_FAILURE: {
      return {
        ...state,
        hasFailure: true,
        isFetching: false,
      };
    }
    case MARK_CLIENT_SELECT: {
      return {
        ...state,
        clientList: state.clientList.map((client) => (client.id === action.clientId ? { ...client, selected: action.mark } : client)),
      };
    }
    case SELECT_ALL_CLIENTS: {
      let newClientList = [];
      if (action.mark) {
        newClientList = state.clientList.map((client) => client.show === true && client.phone && !client.requested_opt_out);
      } else {
        const clientList = state.clientList.slice();
        for (let i = 0; i < clientList.length; i += 1) {
          newClientList.push({ ...clientList[i], show: true, selected: false });
        }
      }

      return {
        ...state,
        clientList: state.clientList.map((client) => (client.show === true ? { ...client, selected: action.mark } : client)),
      };
    }
    case SHOW_HIDE_OPT_CLIENTS: {
      return {
        ...state,
        clientList: state.clientList.map((client) => (client.requested_opt_out === true ? { ...client, show: action.mark } : client)),
        isOptChecked: !action.mark,
      };
    }
    case SHOW_HIDE_NO_PHONE: {
      let clientsFilteredButNoPhone = [];
      let hidePhoneList = [];
      if (action.hide) {
        clientsFilteredButNoPhone = state.clientList.filter((client) => client.show && !client.phone);
        hidePhoneList = state.clientList.map((client) => (client.phone ? client : { ...client, show: client.show && !action.hide }));
      } else {
        const { clientList } = state;
        clientsFilteredButNoPhone = state.clientsFilteredButNoPhone;
        const hiddenIDs = clientsFilteredButNoPhone.map((client) => client.id);
        const newClistList = clientList.slice();
        for (let i = 0; i < newClistList.length; i += 1) {
          if (hiddenIDs.indexOf(newClistList[i].id) >= 0) {
            newClistList[i].show = true;
          }
        }

        hidePhoneList = newClistList;
        clientsFilteredButNoPhone = [];
      }
      return {
        ...state,
        clientList: hidePhoneList,
        isHideWithoutPhone: action.hide,
        clientsFilteredButNoPhone,
      };
    }
    case SET_SMS_MESSAGE: {
      return {
        ...state,
        smsMessage: action.message,
        numOfMessages: action.numOfMessages,
        unique_recipients_count: 0,
        expected_recipient_count: 0,
        numClientsToBeSentOptout: 0,
        messageSent: null,
      };
    }
    case SEND_MARKETING_SMS_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case SEND_MARKETING_SMS_SUCCESS: {
      return {
        ...state,
        smsMessage: '',
        messageSent: true,
        isFetching: false,
        numOfMessages: 0,
        expected_recipient_count: 0,
        expected_count: 0,
        numClientsToBeSentOptout: 0,
        originalRecipientsCount: 0,
        sms_credits_available: action.response.sms_credits_available,
      };
    }
    case SEND_MARKETING_SMS_FAILURE: {
      return {
        ...state,
        isFetching: false,
        messageSent: false,
        errorMessage: action.errorMessage,
      };
    }
    case SET_MESSAGE_SENT: {
      return {
        ...state,
        messageSent: action.tf,
      };
    }
    case FILTER_CLIENT_DATA_SUCCESS: {
      // Filter Stylist & Service
      let calcList = [...state.clientList];
      calcList = calcList.map((client) =>
        action.response.filter((c) => c.id === client.id).length > 0
          ? {
              ...client,
              show: true,
            }
          : { ...client, show: false },
      );

      // Filtering Last Visit
      const today = moment().startOf('day');

      switch (state.selectedLastVisit) {
        case '>7days': {
          calcList = calcList.map((client) =>
            client.last_visit && client.show === true && today.diff(moment(client.last_visit), 'days') <= 6
              ? {
                  ...client,
                  show: true,
                }
              : { ...client, show: false },
          );
          break;
        }
        case '>12weeks': {
          calcList = calcList.map((client) =>
            client.last_visit && client.show === true && today.diff(moment(client.last_visit), 'weeks') > 12
              ? {
                  ...client,
                  show: true,
                }
              : { ...client, show: false },
          );
          break;
        }
        case '<1year': {
          calcList = calcList.map((client) =>
            client.last_visit && client.show === true && today.diff(moment(client.last_visit), 'days') <= 365
              ? {
                  ...client,
                  show: true,
                }
              : { ...client, show: false },
          );
          break;
        }
        case 'noVisit': {
          calcList = calcList.map((client) =>
            client.last_visit === null && client.show === true
              ? { ...client, show: true }
              : {
                  ...client,
                  show: false,
                },
          );
          break;
        }
        default:
          if (parseInt(state.selectedLastVisit, 10)) {
            const weekNumber = parseInt(state.selectedLastVisit, 10);
            const dayNumber = weekNumber * 7;
            calcList = calcList.map((client) =>
              client.last_visit && client.show === true && today.diff(moment(client.last_visit), 'days') > dayNumber
                ? {
                    ...client,
                    show: true,
                  }
                : { ...client, show: false },
            );
          }
          break;
      }
      // Filtering Next Visit
      switch (state.selectedNextVisit) {
        case 'anyDate': {
          calcList = calcList.map((client) =>
            client.next_visit && client.show === true
              ? { ...client, show: true }
              : {
                  ...client,
                  show: false,
                },
          );
          break;
        }
        case 'next7days': {
          calcList = calcList.map((client) =>
            client.next_visit && client.show === true && today.diff(moment(client.next_visit), 'days') > -8
              ? {
                  ...client,
                  show: true,
                }
              : { ...client, show: false },
          );
          break;
        }
        case 'noFuture': {
          calcList = calcList.map((client) =>
            !client.next_visit && client.show === true
              ? { ...client, show: true }
              : {
                  ...client,
                  show: false,
                },
          );
          break;
        }
        default:
          break;
      }
      //  Filter hide clients with no mobile
      if (state.isHideWithoutPhone) {
        calcList = calcList.map((client) => (client.phone ? client : { ...client, show: false }));
      }
      //  Filter show opted-in clients
      if (state.isOptChecked) {
        calcList = calcList.map((client) => (client.requested_opt_out === false ? client : { ...client, show: false }));
      }
      //  Dissable opted-out clients
      calcList = calcList.map((client) => (client.requested_opt_out === true ? { ...client, selected: false } : client));

      // filter timeRange
      const { lastDatesSelected } = state;
      if (lastDatesSelected) {
        for (let i = 0; i < calcList.length; i += 1) {
          const client = calcList[i];
          const lastVisit = client.last_visit;
          const nextVisit = client.next_visit;

          if (
            lastVisit &&
            moment(lastVisit).isSameOrAfter(moment(lastDatesSelected.fromDate), 'day') &&
            lastVisit &&
            moment(lastVisit).isSameOrBefore(moment(lastDatesSelected.toDate), 'day') &&
            client.show
          ) {
            client.show = true;
          } else if (
            nextVisit &&
            moment(nextVisit).isSameOrAfter(moment(lastDatesSelected.fromDate), 'day') &&
            nextVisit &&
            moment(nextVisit).isSameOrBefore(moment(lastDatesSelected.toDate), 'day') &&
            client.show
          ) {
            client.show = true;
          } else {
            client.show = false;
          }
        }
      }
      // filter loyalty
      if (state.selectedLoyalty.isAnyAmount !== undefined) {
        if (state.selectedLoyalty.isAnyAmount === true) {
          calcList = calcList.map((client) =>
            client.visits_total_cost > state.selectedLoyalty.amount
              ? client
              : {
                  ...client,
                  show: false,
                },
          );
        }

        if (state.selectedLoyalty.number > 0) {
          calcList = calcList.map((client) => (client.visits_count >= state.selectedLoyalty.number ? client : { ...client, show: false }));
        }
      }
      return {
        ...state,
        clientList: calcList,
        loadingClientsData: false,
        isFetching: false,
      };
    }
    case FILTER_SELECTED_STYLISTS: {
      return {
        ...state,
        selectedStylistIds: action.selectedStylistIds,
      };
    }
    case FILTER_SERVICES: {
      return {
        ...state,
        selectedServices: action.selectedServices,
      };
    }
    case FILTER_LAST_VISIT: {
      return {
        ...state,
        selectedLastVisit: action.option,
      };
    }
    case FILTER_NEXT_VISIT: {
      return {
        ...state,
        selectedNextVisit: action.option,
      };
    }
    case FILTER_LOYALTY: {
      const parseAmount = parseFloat(action.amount);
      return {
        ...state,
        selectedLoyalty: {
          isAnyAmount: action.isAnyAmount,
          amount: parseAmount,
          isAnyNumber: action.isAnyNumber,
          number: action.number,
        },
      };
    }
    case FILTER_TIME_RANGE: {
      const { lastDatesSelected } = state;
      const calcList = state.clientList.slice();

      if (lastDatesSelected) {
        for (let i = 0; i < calcList.length; i += 1) {
          const client = calcList[i];
          const lastVisit = client.last_visit;
          const nextVisit = client.next_visit;
          if (lastVisit && moment(lastVisit).isSameOrAfter(moment(lastDatesSelected.fromDate), 'day') && lastVisit && moment(lastVisit).isSameOrBefore(moment(lastDatesSelected.toDate), 'day')) {
            client.show = true;
          } else if (
            nextVisit &&
            moment(nextVisit).isSameOrAfter(moment(lastDatesSelected.fromDate), 'day') &&
            nextVisit &&
            moment(nextVisit).isSameOrBefore(moment(lastDatesSelected.toDate), 'day')
          ) {
            client.show = true;
          } else {
            client.show = false;
          }
        }
      }

      return { ...state, clientList: calcList };
    }

    case SET_TIME_RANGE: {
      const bgn = action?.fromDate ? action?.fromDate : state.lastDatesSelected?.fromDate;
      const end = action?.toDate ? action?.toDate : null;

      const fromDate = bgn ? moment(bgn) : bgn;
      const toDate = moment(end).isBefore(moment(bgn)) ? moment(bgn).add(6, 'day').endOf('day') : end;

      L.debug('()', action, { fromDate, toDate }, { bgn, end, lastDatesSelected: state.lastDatesSelected });
      return { ...state, lastDatesSelected: { fromDate, toDate } };
    }

    case CLEAR_TIME_RANGE: {
      return { ...state, lastDatesSelected: null };
    }
    case SET_OPT_VALUE: {
      return {
        ...state,
        isOptChecked: action.optValue,
      };
    }
    case SET_HIDE_PHONE_VALUE: {
      return {
        ...state,
        isHideWithoutPhone: action.isHideValue,
      };
    }
    case SORT_CLIENT_LIST: {
      const sortList = state.clientList.slice();
      switch (action.tableRow) {
        // eslint-disable-next-line no-lone-blocks
        case 'clientName': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.user_name.toLowerCase() < b.user_name.toLowerCase() ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.user_name.toLowerCase() > b.user_name.toLowerCase() ? -1 : 1));
          }
          break;
        }
        case 'mobile': {
          if (action.isAsc) {
            sortList.sort((a, b) => {
              if (a.phone && !b.phone) return -1;
              if (!a.phone && b.phone) return 1;
              return a.phone - b.phone;
            });
          } else {
            sortList.sort((a, b) => {
              if (a.phone && !b.phone) return 1;
              if (!a.phone && b.phone) return -1;
              return b.phone - a.phone;
            });
          }
          break;
        }
        case 'lastVisit': {
          if (action.isAsc) {
            sortList.sort((a, b) =>
              (a.last_visit === null ? moment(1e15).format('YYYYMMDD') : moment(a.last_visit).format('YYYYMMDD')) >
              (b.last_visit === null ? moment(1e15).format('YYYYMMDD') : moment(b.last_visit).format('YYYYMMDD'))
                ? 1
                : -1,
            );
          } else {
            sortList.sort((a, b) =>
              (b.last_visit === null ? moment(-1e15).format('YYYYMMDD') : moment(b.last_visit).format('YYYYMMDD')) >
              (a.last_visit === null ? moment(-1e15).format('YYYYMMDD') : moment(a.last_visit).format('YYYYMMDD'))
                ? 1
                : -1,
            );
          }
          break;
        }
        case 'nextVisit': {
          if (action.isAsc) {
            sortList.sort((a, b) =>
              (a.next_visit === null ? moment(1e15).format('YYYYMMDD') : moment(a.next_visit).format('YYYYMMDD')) >
              (b.next_visit === null ? moment(1e15).format('YYYYMMDD') : moment(b.next_visit).format('YYYYMMDD'))
                ? 1
                : -1,
            );
          } else {
            sortList.sort((a, b) =>
              (b.next_visit === null ? moment(-1e15).format('YYYYMMDD') : moment(b.next_visit).format('YYYYMMDD')) >
              (a.next_visit === null ? moment(-1e15).format('YYYYMMDD') : moment(a.next_visit).format('YYYYMMDD'))
                ? 1
                : -1,
            );
          }
          break;
        }
        case 'totalVisits': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.visits_count > b.visits_count ? 1 : -1));
          } else {
            sortList.sort((a, b) => (b.visits_count > a.visits_count ? 1 : -1));
          }
          break;
        }
        case 'totalSpend': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.visits_total_cost > b.visits_total_cost ? 1 : -1));
          } else {
            sortList.sort((a, b) => (b.visits_total_cost > a.visits_total_cost ? 1 : -1));
          }
          break;
        }
        case 'noShow': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.no_shows_count > b.no_shows_count ? 1 : -1));
          } else {
            sortList.sort((a, b) => (b.no_shows_count > a.no_shows_count ? 1 : -1));
          }
          break;
        }
        case 'Cancellations': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.canceled_count > b.canceled_count ? 1 : -1));
          } else {
            sortList.sort((a, b) => (b.canceled_count > a.canceled_count ? 1 : -1));
          }
          break;
        }
        case 'clientTags': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.client_tags > b.client_tags ? 1 : -1));
          } else {
            sortList.sort((a, b) => (b.client_tags > a.client_tags ? 1 : -1));
          }
          break;
        }
        case 'averageBill': {
          if (action.isAsc) {
            sortList.sort((a, b) =>
              Math.round(a.visits_count === 0 ? 0 : ((a.visits_total_cost / a.visits_count) * 100) / 100) > Math.round(b.visits_count === 0 ? 0 : ((b.visits_total_cost / b.visits_count) * 100) / 100)
                ? 1
                : -1,
            );
          } else {
            sortList.sort((a, b) =>
              Math.round(a.visits_count === 0 ? 0 : ((a.visits_total_cost / a.visits_count) * 100) / 100) < Math.round(b.visits_count === 0 ? 0 : ((b.visits_total_cost / b.visits_count) * 100) / 100)
                ? 1
                : -1,
            );
          }
          break;
        }
        case 'lastSmsSent': {
          if (action.isAsc) {
            sortList.sort((a, b) =>
              (a.last_marketing_message === null ? moment(1e15).format('YYYYMMDD') : moment(a.last_marketing_message).format('YYYYMMDD')) >
              (b.last_marketing_message === null ? moment(1e15).format('YYYYMMDD') : moment(b.last_marketing_message).format('YYYYMMDD'))
                ? 1
                : -1,
            );
          } else {
            sortList.sort((a, b) =>
              (b.last_marketing_message === null ? moment(-1e15).format('YYYYMMDD') : moment(b.last_marketing_message).format('YYYYMMDD')) >
              (a.last_marketing_message === null ? moment(-1e15).format('YYYYMMDD') : moment(a.last_marketing_message).format('YYYYMMDD'))
                ? 1
                : -1,
            );
          }
          break;
        }
        case 'email': {
          if (action.isAsc) {
            sortList.sort((a, b) => ((a.email === null ? 1 : a.email > b.email) ? 1 : -1));
          } else {
            sortList.sort((a, b) => ((b.email === null ? 1 : b.email > a.email) ? 1 : -1));
          }
          break;
        }
        case 'invalid_patch_test': {
          if (action.isAsc) {
            const sortFunc = (a, b) => {
              if (a.patch_test_date === null) {
                return 1;
              }
              if (b.patch_test_date === null) {
                return -1;
              }
              const newStrA = a.patch_test_date.split('/').reverse().join('');
              const newStrB = b.patch_test_date.split('/').reverse().join('');

              if (moment(newStrA).isAfter(moment(newStrB))) {
                return 1;
              }
              return -1;
            };
            sortList.sort(sortFunc);
          } else {
            const sortFunc = (a, b) => {
              if (a.patch_test_date === null) {
                return -1;
              }
              if (b.patch_test_date === null) {
                return 1;
              }
              const newStrA = a.patch_test_date.split('/').reverse().join('');
              const newStrB = b.patch_test_date.split('/').reverse().join('');
              if (moment(newStrA).isAfter(moment(newStrB))) {
                return -1;
              }
              return 1;
            };
            sortList.sort(sortFunc);
          }
          break;
        }
        case 'birthday': {
          if (action.isAsc) {
            const sortFunc = (a, b) => {
              if (a.birthday === null) {
                return 1;
              }
              if (b.birthday === null) {
                return -1;
              }
              let newStrA;
              let newStrB;
              // no birthyear
              if (a.birthday.length < 6) {
                newStrA = `2020${a.birthday.split('/').reverse().join('')}`;
              } else {
                newStrA = a.birthday.split('/').reverse().join('');
              }
              if (b.birthday.length < 6) {
                newStrB = `2020${b.birthday.split('/').reverse().join('')}`;
              } else {
                newStrB = b.birthday.split('/').reverse().join('');
              }
              if (moment(newStrA).isAfter(moment(newStrB))) {
                return 1;
              }
              return -1;
            };
            sortList.sort(sortFunc);
          } else {
            const sortFunc = (a, b) => {
              if (a.birthday === null) {
                return -1;
              }
              if (b.birthday === null) {
                return 1;
              }
              let newStrA;
              let newStrB;
              // no birthyear
              if (a.birthday.length < 6) {
                newStrA = `2020${a.birthday.split('/').reverse().join('')}`;
              } else {
                newStrA = a.birthday.split('/').reverse().join('');
              }
              if (b.birthday.length < 6) {
                newStrB = `2020${b.birthday.split('/').reverse().join('')}`;
              } else {
                newStrB = b.birthday.split('/').reverse().join('');
              }
              if (moment(newStrA).isAfter(moment(newStrB))) {
                return -1;
              }
              return 1;
            };
            sortList.sort(sortFunc);
          }
          break;
        }
        default:
          break;
      }
      return {
        ...state,
        clientList: sortList,
      };
    }
    case GET_UNIQUE_CLIENTS_ESTIMATE_REQUEST: {
      return {
        ...state,
        isFetching: true,
        originalRecipientsCount: action.params.data.recipients.length,
        clientHasNoPhone: false,
      };
    }
    case GET_UNIQUE_CLIENTS_ESTIMATE_SUCCESS: {
      return {
        ...state,
        expected_recipient_count: action.response.expected_count,
        numClientsToBeSentOptout: action.response.opt_out_messages_count,
        expected_count: action.response.expected_count,
        unique_recipients_count: action.response.unique_recipients_count,
        isFetching: false,
        sms_credits_available: action.response.sms_credits_available,
        numOfMessages: action.response.length,
        sending_allowed: action.response.sending_allowed,
        clientHasNoPhone: false,
      };
    }
    case GET_UNIQUE_CLIENTS_ESTIMATE_FAILURE: {
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
        clientHasNoPhone: true,
      };
    }
    case GET_MARKETING_CAMPAIGNS_SUCCESS: {
      const calcCampaigns = action.response.messages.map((p) => ({ ...p, isCollapsed: false }));
      const blastSmsByMonth = groupBy(action.response.messages, (blastMessage) => moment(blastMessage.timestamp).startOf('month').format('MMMM YYYY'));
      calcCampaigns.sort((a, b) => (moment(a.timestamp).format('YYYYMMDD') > moment(b.timestamp).format('YYYYMMDD') ? -1 : 1));
      // !!!! guan m.timestamp need to change to appointment starttime
      calcCampaigns.forEach((m) => {
        if (m.bucket === 'appointment') {
          m.bucket = `Booking on ${moment(m.appointment_time).format('ddd, MMMM Do YYYY')}`;
        }
      });
      return {
        ...state,
        campaignsSent: action.response.messages.length,
        clientsMessaged: action.response.total_clients_count,
        revenueGenerated: action.response.total_revenue,
        bookingsRecieved: action.response.total_appointments_count,
        campaigns: calcCampaigns,
        isFetching: false,
        blastSmsByMonth: Object.entries(blastSmsByMonth).reverse(),
      };
    }
    // /sms/direct/ api
    case GET_MANUAL_MESSAGES_ONLY_SUCCESS: {
      const blastSms = action.response.messages.map((p) => ({ ...p, isCollapsed: false }));
      blastSms.sort((a, b) => (moment(a.timestamp).format('YYYYMMDD') > moment(b.timestamp).format('YYYYMMDD') ? -1 : 1));
      blastSms.forEach((m) => {
        if (m.bucket === 'appointment') {
          m.bucket = `Booking on ${moment(m.appointment_time).format('ddd, MMMM Do YYYY')}`;
        }
      });
      const oneToOneSmsByMonth = groupBy(blastSms, (b) => moment(b.timestamp).startOf('month').format('MMMM YYYY'));
      return {
        ...state,
        campaignsSentDirect: action.response.messages.filter((message) => message.id > 0).length,
        clientsMessagedDirect: action.response.total_clients_count,
        revenueGeneratedDirect: action.response.total_revenue,
        bookingsRecievedDirect: action.response.total_appointments_count,
        blastSms,
        oneToOneSmsByMonth: Object.entries(oneToOneSmsByMonth),
        isFetching: false,
      };
    }
    case SET_SHOW_CAMPAIGN_DETAILS: {
      const changeCapmVisibility = state.campaigns.map((campaign) =>
        campaign.id === action.campaignId
          ? {
              ...campaign,
              isCollapsed: action.show,
            }
          : campaign,
      );
      // blastSms
      const changeBlastCapmVisibility = state.blastSms.map((campaign) =>
        campaign.id === action.campaignId
          ? {
              ...campaign,
              isCollapsed: action.show,
            }
          : campaign,
      );
      const { blastSmsByMonth } = state;
      const updatedBlastSmsByMonth = blastSmsByMonth.slice();
      for (let i = 0; i < updatedBlastSmsByMonth.length; i += 1) {
        for (let j = 0; j < updatedBlastSmsByMonth[i][1].length; j += 1) {
          if (updatedBlastSmsByMonth[i][1][j].id === action.campaignId) {
            updatedBlastSmsByMonth[i][1][j] = { ...updatedBlastSmsByMonth[i][1][j], clients: [], isCollapsed: false };
          }
        }
      }
      return {
        ...state,
        campaigns: changeCapmVisibility,
        blastSms: changeBlastCapmVisibility,
        blastSmsByMonth: updatedBlastSmsByMonth,
      };
    }
    case GET_CAMPAIGN_CLIENTS_SUCCESS: {
      const { autoSmsByMonth, oneToOneSmsByMonth } = state;
      const changeCapmVisibility = state.campaigns.map((campaign) =>
        campaign.id === action.params.campaignId
          ? {
              ...campaign,
              isCollapsed: action.params.show,
              recipients: action.response.sort((a, b) => (a.appointments_count > b.appointments_count ? -1 : 1)),
            }
          : campaign,
      );
      const changeBlastCapmVisibility = state.blastSms.map((campaign) =>
        campaign.id === action.params.campaignId
          ? {
              ...campaign,
              isCollapsed: action.params.show,
              recipients: action.response.sort((a, b) => (a.appointments_count > b.appointments_count ? -1 : 1)),
            }
          : campaign,
      );
      let { autoMessages } = state;
      const { blastSmsByMonth } = state;
      let updatedAutoSmsByMonth = autoSmsByMonth ? autoSmsByMonth.slice() : [];
      let updatedBlastSmsByMonth = blastSmsByMonth.slice();
      if (action.params.campaignId) {
        if (action.params.isAutoMsg) {
          autoMessages = autoMessages.map((campaign) =>
            campaign.id === action.params.campaignId
              ? {
                  ...campaign,
                  isCollapsed: action.params.show,
                  recipients: action.response.sort((a, b) => (a.appointments_count > b.appointments_count ? -1 : 1)),
                }
              : campaign,
          );

          if (autoSmsByMonth) {
            updatedAutoSmsByMonth = autoSmsByMonth.slice();
            for (let i = 0; i < updatedAutoSmsByMonth.length; i += 1) {
              for (let j = 0; j < updatedAutoSmsByMonth[i][1].length; j += 1) {
                if (updatedAutoSmsByMonth[i][1][j].id === action.params.campaignId) {
                  const updatedClients = action.params.show ? action.response : [];
                  updatedAutoSmsByMonth[i][1][j] = {
                    ...updatedAutoSmsByMonth[i][1][j],
                    clients: updatedClients,
                    isCollapsed: action.params.show,
                  };
                }
              }
            }
          }
        }
        if (blastSmsByMonth) {
          updatedBlastSmsByMonth = blastSmsByMonth.slice();
          for (let i = 0; i < updatedBlastSmsByMonth.length; i += 1) {
            for (let j = 0; j < updatedBlastSmsByMonth[i][1].length; j += 1) {
              if (updatedBlastSmsByMonth[i][1][j].id === action.params.campaignId) {
                updatedBlastSmsByMonth[i][1][j] = {
                  ...updatedBlastSmsByMonth[i][1][j],
                  clients: action.response,
                  isCollapsed: action.params.show,
                };
              }
            }
          }
        }
        if (oneToOneSmsByMonth) {
          for (let i = 0; i < oneToOneSmsByMonth.length; i += 1) {
            for (let j = 0; j < oneToOneSmsByMonth[i][1].length; j += 1) {
              if (oneToOneSmsByMonth[i][1][j].id === action.params.campaignId) {
                oneToOneSmsByMonth[i][1][j] = {
                  ...oneToOneSmsByMonth[i][1][j] /* recipients_details: action.response[0],  */,
                  clients: action.response,
                  isCollapsed: action.params.show,
                };
              }
            }
          }
        }
      }
      return {
        ...state,
        campaigns: changeCapmVisibility,
        autoMessages,
        blastSms: changeBlastCapmVisibility,
        isFetching: false,
        autoSmsByMonth: updatedAutoSmsByMonth,
        blastSmsByMonth: updatedBlastSmsByMonth,
        oneToOneSmsByMonth,
      };
    }
    case SORT_CAMPAIGN_LIST: {
      const sortList = [...state.campaigns];
      let sortBlastSmsList = state.blastSmsByMonth.slice();
      const sort121SmsList = state.oneToOneSmsByMonth.slice();
      switch (action.row) {
        case 'dateSent': {
          if (action.isAsc) {
            sortList.sort((a, b) => (moment(a.timestamp).isAfter(moment(b.timestamp)) ? -1 : 1));
            sortBlastSmsList.sort((a, b) => (moment(a[0]).isAfter(moment(b[0])) ? -1 : 1));
            sort121SmsList.sort((a, b) => (moment(a[0]).isAfter(moment(b[0])) ? -1 : 1));
          } else {
            sortList.sort((a, b) => (moment(a.timestamp).isBefore(moment(b.timestamp)) ? -1 : 1));
            sortBlastSmsList.sort((a, b) => (moment(a[0]).isBefore(moment(b[0])) ? -1 : 1));
            sort121SmsList.sort((a, b) => (moment(a[0]).isBefore(moment(b[0])) ? -1 : 1));
          }
          break;
        }
        case 'recipients': {
          const sortFunc = (a, b) => (action.isAsc ? a.unique_recipients_count - b.unique_recipients_count : b.unique_recipients_count - a.unique_recipients_count);
          sortList.sort(sortFunc);
          const sortFunc2 = (a, b) => {
            const numRecipientsA = a[1].reduce((totalClient, e) => (totalClient += e.unique_recipients_count), 0);
            const numRecipientsB = b[1].reduce((totalClient, e) => (totalClient += e.unique_recipients_count), 0);
            return action.isAsc ? numRecipientsA - numRecipientsB : numRecipientsB - numRecipientsA;
          };
          const sortFunc3 = (a, b) => (action.isAsc ? a[1].length - b[1].length : b[1].length - a[1].length);
          sortBlastSmsList = sortBlastSmsList.sort(sortFunc2);
          sort121SmsList.sort(sortFunc3);
          break;
        }
        case 'targetAudience': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.bucket > b.bucket ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.bucket < b.bucket ? -1 : 1));
          }
          break;
        }
        case 'bookingRecieved': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.appointments_count > b.appointments_count ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.appointments_count < b.appointments_count ? -1 : 1));
          }
          const sortFunc = (a, b) => {
            const numAppsA = a[1].reduce((totalAppsValue, e) => (totalAppsValue += e.appointments_count ? e.appointments_count : 0), 0);
            const numAppsB = b[1].reduce((totalAppsValue, e) => (totalAppsValue += e.appointments_count ? e.appointments_count : 0), 0);
            return action.isAsc ? numAppsA - numAppsB : numAppsB - numAppsA;
          };
          sortBlastSmsList.sort(sortFunc);
          sort121SmsList.sort(sortFunc);
          break;
        }
        case 'bookingValue': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.revenue > b.revenue ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.revenue < b.revenue ? -1 : 1));
          }
          const sortFunc = (a, b) => {
            const numValueA = a[1].reduce((totalValue, e) => (totalValue += e.revenue ? e.revenue : 0), 0);
            const numValueB = b[1].reduce((totalValue, e) => (totalValue += e.revenue ? e.revenue : 0), 0);
            return action.isAsc ? numValueA - numValueB : numValueB - numValueA;
          };
          sortBlastSmsList.sort(sortFunc);
          sort121SmsList.sort(sortFunc);
          break;
        }
        case 'smsSent': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.sms_count > b.sms_count ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.sms_count < b.sms_count ? -1 : 1));
          }
          const sortFunc = (a, b) => {
            const numSmsCountA = a[1].reduce((totalSmsCount, e) => (totalSmsCount += e.sms_count), 0);
            const numSmsCountB = b[1].reduce((totalSmsCount, e) => (totalSmsCount += e.sms_count), 0);
            return action.isAsc ? numSmsCountA - numSmsCountB : numSmsCountB - numSmsCountA;
          };
          sortBlastSmsList.sort(sortFunc);
          sort121SmsList.sort(sortFunc);
          break;
        }
        case 'smsCost': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.cost > b.cost ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.cost < b.cost ? -1 : 1));
          }
          const sortFunc = (a, b) => {
            const numCostA = a[1].reduce((totalSmsCost, e) => (totalSmsCost += owns('cost', e) ? e.cost * e.recipients.length : 0.05 * e.recipients.length), 0);
            const numCostB = b[1].reduce((totalSmsCost, e) => (totalSmsCost += owns('cost', e) ? e.cost * e.recipients.length : 0.05 * e.recipients.length), 0);
            return action.isAsc ? numCostA - numCostB : numCostB - numCostA;
          };
          sortBlastSmsList.sort(sortFunc);
          sort121SmsList.sort(sortFunc);
          break;
        }
        default:
          break;
      }
      return {
        ...state,
        campaigns: sortList,
        blastSmsByMonth: sortBlastSmsList,
        groupOrderChanged: `${action.row} ${action.isAsc}`,
        oneToOneSmsByMonth: sort121SmsList,
      };
    }
    case SORT_AUTO_SMS_BY_MONTH: {
      const autoSmsByMonth = state.autoSmsByMonth ?? [];
      let updatedAutoSmsByMonth;
      switch (action.row) {
        case 'recipients': {
          const sortFunc = (a, b) => {
            const numRecipientsA = a[1].reduce((totalClient, e) => (totalClient += e.unique_recipients_count), 0);
            const numRecipientsB = b[1].reduce((totalClient, e) => (totalClient += e.unique_recipients_count), 0);
            return action.isAsc ? numRecipientsA - numRecipientsB : numRecipientsB - numRecipientsA;
          };
          updatedAutoSmsByMonth = autoSmsByMonth.sort(sortFunc);
          break;
        }
        case 'dateSent': {
          const sortFunc = (a, b) => {
            if (action.isAsc) {
              return moment(a[0]).isAfter(moment(b[0])) ? -1 : 1;
            }
            return moment(a[0]).isAfter(moment(b[0])) ? 1 : -1;
          };
          updatedAutoSmsByMonth = autoSmsByMonth.sort(sortFunc);
          break;
        }
        case 'smsCount': {
          const sortFunc = (a, b) => {
            const numSmsA = a[1].reduce((totalSms, e) => (totalSms += e.sms_count), 0);
            const numSmsB = b[1].reduce((totalSms, e) => (totalSms += e.sms_count), 0);
            return action.isAsc ? numSmsA - numSmsB : numSmsB - numSmsA;
          };
          updatedAutoSmsByMonth = autoSmsByMonth.sort(sortFunc);
          break;
        }

        case 'bookingReceived': {
          const sortFunc = (a, b) => {
            const countA = a[1].reduce((appointmentCount, e) => (appointmentCount += e.appointments_count), 0);
            const countB = b[1].reduce((appointmentCount, e) => (appointmentCount += e.appointments_count), 0);
            return action.isAsc ? countA - countB : countB - countA;
          };
          updatedAutoSmsByMonth = autoSmsByMonth.sort(sortFunc);
          break;
        }
        case 'revenue': {
          const sortFunc = (a, b) => {
            const countA = a[1].reduce((rev, e) => (rev += e.revenue), 0);
            const countB = b[1].reduce((rev, e) => (rev += e.revenue), 0);
            return action.isAsc ? countA - countB : countB - countA;
          };
          updatedAutoSmsByMonth = autoSmsByMonth.sort(sortFunc);
          break;
        }
        case 'smsCost': {
          const sortFunc = (a, b) => {
            const smsA = a[1].reduce((sms, e) => (sms += e.cost), 0);
            const smsB = b[1].reduce((sms, e) => (sms += e.cost), 0);
            return action.isAsc ? smsA - smsB : smsB - smsA;
          };
          updatedAutoSmsByMonth = autoSmsByMonth.sort(sortFunc);
          break;
        }
        default:
          break;
      }
      return {
        ...state,
        autoSmsByMonth: updatedAutoSmsByMonth,
        groupOrderChanged: `${action.row} ${action.isAsc}`,
      };
    }
    case SORT_CAMPAIGN_CLIENT_LIST: {
      const sortList = [...state.campaigns];
      const sortBlastSmsList = [...state.blastSms];
      if (action.row === 'user_name') {
        if (action.isAsc) {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.user_name > b.user_name ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.user_name > b.user_name ? 1 : -1)),
                }
              : campaign,
          );
        } else {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.user_name < b.user_name ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.user_name < b.user_name ? 1 : -1)),
                }
              : campaign,
          );
        }
      }
      if (action.row === 'phone') {
        if (action.isAsc) {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.phone < b.phone ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.phone < b.phone ? 1 : -1)),
                }
              : campaign,
          );
        } else {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.phone > b.phone ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.phone > b.phone ? 1 : -1)),
                }
              : campaign,
          );
        }
      }
      if (action.row === 'appointments_count') {
        if (action.isAsc) {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.appointments_count > b.appointments_count ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.appointments_count > b.appointments_count ? 1 : -1)),
                }
              : campaign,
          );
        } else {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.appointments_count < b.appointments_count ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.appointments_count < b.appointments_count ? 1 : -1)),
                }
              : campaign,
          );
        }
      }
      if (action.row === 'revenue') {
        if (action.isAsc) {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.revenue > b.revenue ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.revenue > b.revenue ? 1 : -1)),
                }
              : campaign,
          );
        } else {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.revenue < b.revenue ? 1 : -1)),
                }
              : campaign,
          );
          sortBlastSmsList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.revenue < b.revenue ? 1 : -1)),
                }
              : campaign,
          );
        }
      }
      return {
        ...state,
        campaigns: sortList,
        blastSms: sortBlastSmsList,
      };
    }
    case SORT_AUTO_MSG_LIST: {
      const { autoSmsByMonth } = state;
      let clients = [];
      for (let i = 0; i < autoSmsByMonth.length; i += 1) {
        for (let j = 0; j < autoSmsByMonth[i][1].length; j += 1) {
          if (autoSmsByMonth[i][1][j].id === action.campaignId) {
            clients = autoSmsByMonth[i][1][j].clients;
          }
        }
      }

      const sortList = clients;
      switch (action.row) {
        case 'user_name': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.user_name > b.user_name ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.user_name < b.user_name ? -1 : 1));
          }
          break;
        }
        case 'phone': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.phone > b.phone ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.phone < b.phone ? -1 : 1));
          }
          break;
        }
        case 'revenue': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.revenue > b.revenue ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.revenue < b.revenue ? -1 : 1));
          }
          break;
        }
        case 'appointments_count': {
          if (action.isAsc) {
            sortList.sort((a, b) => (a.appointments_count > b.appointments_count ? -1 : 1));
          } else {
            sortList.sort((a, b) => (a.appointments_count < b.appointments_count ? -1 : 1));
          }
          break;
        }
        default:
          break;
      }

      return {
        ...state,
        autoSmsByMonth,
      };
    }
    case SORT_AUTO_MSG_CLIENT_LIST: {
      const sortList = [...state.autoMessages];

      if (action.row === 'user_name') {
        if (action.isAsc) {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.user_name > b.user_name ? 1 : -1)),
                }
              : campaign,
          );
        } else {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.user_name < b.user_name ? 1 : -1)),
                }
              : campaign,
          );
        }
      }
      if (action.row === 'phone') {
        if (action.isAsc) {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.phone < b.phone ? 1 : -1)),
                }
              : campaign,
          );
        } else {
          sortList.map((campaign) =>
            campaign.id === action.messageId
              ? {
                  ...campaign,
                  recipients: campaign.recipients.sort((a, b) => (a.phone > b.phone ? 1 : -1)),
                }
              : campaign,
          );
        }
      }

      return {
        ...state,
        autoMessages: sortList,
      };
    }
    case SET_SHOW_AUTOMSG_DETAILS: {
      const { autoSmsByMonth } = state;
      const changeCapmVisibility = state.autoMessages.map((campaign) =>
        campaign.id === action.campaignId
          ? {
              ...campaign,
              isCollapsed: action.show,
            }
          : campaign,
      );
      const updatedAutoSmsByMonth = autoSmsByMonth.slice();
      for (let i = 0; i < updatedAutoSmsByMonth.length; i += 1) {
        for (let j = 0; j < updatedAutoSmsByMonth[i][1].length; j += 1) {
          if (updatedAutoSmsByMonth[i][1][j].id === action.campaignId) {
            updatedAutoSmsByMonth[i][1][j] = {
              ...updatedAutoSmsByMonth[i][1][j],
              clients: null,
              isCollapsed: action.show,
            };
          }
        }
      }
      return {
        ...state,
        autoMessages: changeCapmVisibility,
        autoSmsByMonth: updatedAutoSmsByMonth,
      };
    }
    case GET_MARKETING_CAMPAIGNS_REQUEST:
    case GET_MANUAL_MESSAGES_ONLY_REQUEST:
    case GET_CAMPAIGN_CLIENTS_REQUEST:
    case GET_CAMPAIGN_BOOKINGS_REQUEST:
    case GET_AUTO_MESSAGES_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    // /sms/auto/ api
    case GET_AUTO_MESSAGES_SUCCESS: {
      if (action.response.messages.length > 0) {
        const autoMessages = action.response.messages.sort((a, b) => (moment(a.timestamp).format('YYYYMMDD') > moment(b.timestamp).format('YYYYMMDD') ? -1 : 1));
        const autoSmsByMonth = groupBy(autoMessages, (autoMessage) => moment(autoMessage.timestamp).startOf('month').format('MMMM YYYY'));
        return {
          ...state,
          campaignsSentAuto: action.response.messages.length,
          clientsMessagedAuto: action.response.total_clients_count,
          revenueGeneratedAuto: action.response.total_revenue,
          bookingsRecievedAuto: action.response.total_appointments_count,
          autoMessages,
          autoSmsByMonth: Object.entries(autoSmsByMonth),
        };
      }
      return {
        ...state,
        isFetching: false,
      };
    }
    case GET_CAMPAIGN_BOOKINGS_FAILURE: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case GET_CAMPAIGN_CLIENTS_FAILURE: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case GET_AUTO_MESSAGES_FAILURE: {
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
      };
    }
    case GET_MARKETING_CAMPAIGNS_FAILURE: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case GET_MANUAL_MESSAGES_ONLY_FAILURE: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case BULK_DELETE_CLIENT_REQUEST: {
      return {
        ...state,
        isFetching: true,
        deleted_count: 0,
        upcoming_clients: [],
        upcoming_count: 0,
        bulkDeleteSuccess: false,
        clients_with_notes: [],
      };
    }
    case BULK_OPTOUT_CLIENT_REQUEST: {
      return {
        ...state,
        isFetching: true,
        bulkOptoutSuccess: false,
      };
    }
    case BULK_DELETE_CLIENT_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        deleted_count: action.response.deleted_count,
        upcoming_clients: action.response.upcoming_clients,
        upcoming_count: action.response.upcoming_count,
        bulkDeleteSuccess: true,
        clients_with_notes: action.response.clients_with_notes,
      };
    }
    case BULK_OPTOUT_CLIENT_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        bulkOptoutSuccess: true,
      };
    }
    case BULK_DELETE_CLIENT_FAILURE: {
      return {
        ...state,
        isFetching: false,
        deleted_count: 0,
        upcoming_clients: [],
        upcoming_count: 0,
        bulkDeleteSuccess: false,
      };
    }
    case REST_BULK_DELETE_RESPONSE: {
      return {
        ...state,
        deleted_count: 0,
        upcoming_clients: [],
        upcoming_count: 0,
        bulkOptoutSuccess: false,
        clients_with_notes: [],
      };
    }
    case BULK_OPTOUT_CLIENT_FAILURE: {
      return {
        ...state,
        isFetching: false,
        bulkOptoutSuccess: false,
      };
    }
    case SMS_CREDITS_PUSHER: {
      return {
        ...state,
        sms_credits_available: action.data.data.data.sms_credits_available,
      };
    }
    case SALON_DETAILS_SUCCESS: {
      return {
        ...state,
        sms_credits_available: action.response.sms_credits_available,
      };
    }
    case SET_AUTO_SMS_BY_MONTH: {
      return {
        ...state,
        autoSmsByMonth: Object.entries(action.autoSmsByMonth),
      };
    }
    default:
      return state;
  }
};

export default clientCommunicationsReducer;
